/*
 * Mobile - Side Cart - Increase Image Size  --  variant: 150px Width
 * Moonshot experiment id: 21085512   status in Moonshot on 2026-08-27: DEPLOYED   started: 2026-02-16
 * Audience: MOBILE   Target: side_cart   (see MGExp.targets in mg-exp-runtime.js)
 * Source: verbatim variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         only change is window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Enabled by theme setting: mgexp_sc_m_image_size
 */
MGExp.run('sc_m_image_size', { name: "Mobile - Side Cart - Increase Image Size / 150px Width", platform: 'mobile', target: 'side_cart' }, function () {
  !(function () {
    let i = [],
      e = [];
    i.push(
      ".msai-increase-image-size-applied#mini-cart-items-list li .bag-image",
      ".msai-increase-image-size-applied#mini-cart-items-list li .bag-description",
      ".msai-increase-image-size-applied#mini-cart-items-list li .bag-image img",
      ".msai-increase-image-size-applied#mini-cart-items-list li .bag-line-item",
      ".msai-increase-image-size-applied#mini-cart-items-list li .bag-remove",
    );
    !(async function (a, t, n, m, s) {
      let r = {
        multi_target_selectors: i,
        page_identifier_selector: "#mini-cart-modal",
        exclude_from_timeout: e,
        selector_timeout: 5e3,
      };
      await MGExp.runVariantBlock(a, t, n, m, s, r);
    })(
      ["#mini-cart-items-list"],
      ".msai-increase-image-size-applied",
      function (i, e) {
        const [a] = e;
        a.classList.add("msai-increase-image-size-applied");
      },
      "\n.msai-increase-image-size-applied#mini-cart-items-list li .bag-image {\n  width: 150px !important;\n  flex-shrink: 0 !important;\n  height: 100% !important;\n  margin-right: 12px !important;\n}\n.msai-increase-image-size-applied#mini-cart-items-list li .bag-image img {\n  width: 150px !important;\n  max-width: 150px !important;\n  height: auto !important;\n  object-fit: contain !important;\n}\n.msai-increase-image-size-applied#mini-cart-items-list li .bag-description {\n  margin-left: 12px !important;\n  margin-right: 12px !important;\n}\n.msai-increase-image-size-applied#mini-cart-items-list li .bag-line-item {\n  display: flex !important;\n  align-items: flex-start !important;\n}\n.msai-increase-image-size-applied#mini-cart-items-list li .bag-remove {\n  width: 25px !important;\n}\n",
    );
  })();
});
